export const customDomainRequestPath = IS_PDV ? '' : '/raiz5jee8eiph0eeFooV';
